module.exports = __webpack_public_path__ + "img/mobile_summary_banner.57d2b34b.png";